import { render, staticRenderFns } from "./HeatingSystemSummaryPanel.global.vue?vue&type=template&id=389d246d&lang=pug&"
import script from "./HeatingSystemSummaryPanel.global.vue?vue&type=script&lang=ts&"
export * from "./HeatingSystemSummaryPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports